import { TabList } from "src/shared/components/navigation/tab-menu/TabMenu.types"

export const incidenciasDetailTabs: TabList[] = [
    { label: "Detalle", path: "detalle" },
    { label: "Comentarios", path: "comentarios" },
]
